jQuery(document).ready(function() {

    /* TESTIMONIAL */
	// jQuery('.slider-for').slick({
	//         slidesToShow:1,
	//         slidesToScroll: 1,
	//         dots: true,
	//         autoplay: true,
	//         autoplaySpeed: 4000,
	//         centerMode: true,
	//         focusOnSelect: true,
	//         fade: true

	// });

	/* mobile navigation */ 
    jQuery('.hamburger').click(function(){
        if (jQuery(this).hasClass('open')){
            jQuery(this).removeClass('open');
            jQuery("#wrapper").css("right","0");
            jQuery('body, html').removeClass('scroll-hidden');
            jQuery('.navbar').removeClass('open');
			jQuery('.phone-div').removeClass('phone-visible');
            jQuery('.sub-menu').slideUp();
			
            jQuery('em.submenu-caret').removeClass('toggled');
        }else {
            jQuery(this).addClass('open')
            jQuery("#wrapper").css("right","80%");
            jQuery('body, html').addClass('scroll-hidden');
			jQuery('.phone-div').addClass('phone-visible');
            jQuery('.navbar').addClass('open');
        }				
    })   
    if(jQuery('#phone-menu ul .js-toggle-drop').length > 0){   
        jQuery('#phone-menu ul .js-toggle-drop').append('<em class="submenu-caret"></em>');
    }

    jQuery('.js-toggle-drop').on('click', function () {
        jQuery(this).next().slideToggle();
        jQuery(this).children('em').toggleClass('toggled');
        jQuery(this).parent().siblings().find('ul').slideUp();
        jQuery(this).parent().siblings().find('em').removeClass('toggled');
    });


	
});
